import type { FC, ReactNode } from "react";
import Box from "@mui/material/Box";
import { Sidebar, type SidebarMenuItemEmphasis } from "./Sidebar";
import type { SidebarMenuItemType } from "./SidebarMenuItem";
import { LogoutSidebarItem } from "./SidebarMenuItem";
import { ProfileMenu } from "./ProfileMenu";

type LayoutProps = {
  children: ReactNode;
  sidebarHeader?: ReactNode;
  sidebarMenuItems?: Array<SidebarMenuItemType>;
  menuItemEmphasis?: SidebarMenuItemEmphasis;
};

export const Layout: FC<LayoutProps> = ({ children, sidebarHeader, sidebarMenuItems, menuItemEmphasis }) => {
  return (
    <_Layout
      sidebar={
        <Sidebar
          header={sidebarHeader}
          menuItemEmphasis={menuItemEmphasis}
          sidebarMenuItems={sidebarMenuItems}
          bottomSlot={<ProfileMenu />}
        />
      }
    >
      {children}
    </_Layout>
  );
};

export const LayoutWhenLoading = ({ children }: { children: ReactNode }) => {
  return <_Layout sidebar={<Sidebar hideToggleSidebarButton />}>{children}</_Layout>;
};

export const LayoutWithoutSelectedOrganisation = ({
  children,
  showLogoutButton = true,
}: {
  children: ReactNode;
  showLogoutButton?: boolean;
}) => {
  return (
    <_Layout sidebar={<Sidebar bottomSlot={showLogoutButton ? <LogoutSidebarItem /> : undefined} />}>
      {children}
    </_Layout>
  );
};

type _LayoutProps = { children: ReactNode; sidebar: ReactNode };

const _Layout: FC<_LayoutProps> = ({ children, sidebar }) => {
  return (
    <Box sx={{ display: "flex" }}>
      {sidebar}
      <Box component="main" sx={{ flexGrow: 1, minWidth: 0 }}>
        {children}
      </Box>
    </Box>
  );
};
